import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';

/**
 * Get statistics monitor
 * */
export function* getStatisticsMonitor(from, until) {
    const response = yield call(api.getStatisticsMonitor, from, until);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_STATISTICS_MONITOR.SUCCESS,
            data: response.data,
        });
    }

    yield put({
        type: actionTypes.GET_STATISTICS_MONITOR.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetStatisticsMonitor() {
    while (true) {
        const { from, until } = yield take(actionTypes.GET_STATISTICS_MONITOR.REQUEST);
        yield call(getStatisticsMonitor, from, until);
    }
}

export default [
    watchGetStatisticsMonitor,
]


// WEBPACK FOOTER //
// ./app/sagas/statistics/monitor.js